/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum InputEventType {
  TOUCH_DOWN = 0,
  TOUCH_UP = 1,
  CLICK = 2,
  LONG_CLICK = 3,
  UNHANDLED_CLICK = 4,
  UNHANDLED_LONG_CLICK = 5,
  WATCHED_ELEMENT_SEEN = 6,
}
